<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>Banner管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick()">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={isEnable:true};">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>Banner列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column label="Banner图">
            <template slot-scope="scope" width="150px">
              <img :src="domain+scope.row.imgUrl" :style="{height:'50px'}" alt />
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column label="是否可用">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.isEnable">是</el-tag>
              <el-tag type="warning" v-else>否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="summary" label="备注"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="small"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10,20,30,50,100]"
            layout="total,prev,sizes,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog
      :title="form.id>0?'编辑Banner':'添加Banner'"
      :visible.sync="dialogVisible"
      @opened="dialogOpened()"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
            <el-alert type="warning" style="margin-bottom:20px;">* Banner尺寸：推荐900*300</el-alert>

        <el-form-item prop="title" label="标题" :rules="[{required:true,message:'不能为空'}]">
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>

        <el-form-item label="图片地址" :rules="[{required:true,message:'不能为空'}]">
          <div>
          <div id="uploadBtn1" class="uploader uploader-warning" style="vertical-align:baseline;"></div>
          <img
            id="relativeName"
            :src="domain+form.imgUrl"
            style="height:40px;position:relative;left:10px;top:5px;"
            v-if="form.imgUrl"
          />
          </div>
        </el-form-item>
        <el-form-item prop="sort" label="排序" :rules="[{required:false,message:'不能为空'}]">
          <el-input type="number" v-model.number="form.sort"></el-input>
        </el-form-item>

        <!-- <el-form-item prop="gooid" label="商品关联">
          <el-select
            placeholder="请选择关联商品"
            v-model="form.gooid"
            style="width:100%;"
            clearable
            filterable
            @change="gooSelect"
          >
            <el-option v-for="item in gooList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item prop="linkUrl" label="链接地址">
          <el-input v-model="form.linkUrl" placeholder="请输入链接地址"></el-input>
        </el-form-item> -->
        <el-form-item label="链接地址">
          <el-input v-model="form.linkUrl" placeholder="请输入链接地址"></el-input>

          <!-- <el-cascader v-model="cascader" :options="linkUrl" @change="cascaderChange">
          </el-cascader> -->

          <el-select v-model="link1" filterable placeholder="请选择" @change="linkChange1" clearable>
            <el-option v-for="item in linkUrl" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>

          <el-select v-model="link2" filterable placeholder="请选择" @change="linkChange2" clearable>
            <el-option v-for="item in linkChildren" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="summary" label="备注">
          <el-input v-model="form.summary" placeholder="请输入备注"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="isEnable" label="是否可用" :rules="[{required:true,message:'不能为空'}]">
              <el-switch v-model="form.isEnable"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

  
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import "../../../public/lib/cover/Cover3.0.min.css";
import "../../../public/lib/cover/Cover3.0.min.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {},
      form: {},
      dialogVisible: false,
      submiting: false,
      loading: false,
      tableData: [],
      total: 0,
      currentPage4: 1,
      pageSize: 10,
      gooList: [], //商品列表
      //linkUrl表
      linkUrl:[],
      linkChildren:[],
      link1:"",
      link2:"",
      cascader:[],
    };
  },
  methods: {
    //选择器改变
    // cascaderChange(){
    //   this.form.linkUrl=this.cascader[0]+this.cascader[1];
    // },
    linkChange1(){
      var _this=this;
      if(_this.link1=="")
        _this.link2="";
      this.linkUrl.forEach(e => {
        if(e.value==_this.link1){
          _this.linkChildren=e.children;
          _this.link2="";
        }
      });
    },
    linkChange2(){
      if(this.link1!=""&&this.link2!="")
        this.form.linkUrl=this.link1+this.link2;
    },
    //获取linkUrl表
    getLinkUrl(){
      var _this=this;
      var link=url.getArt("getlink_banner");
      $.get(link,{},data=>{
        _this.linkUrl=data;
      })
    },
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage41;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.getList();
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getArt("getlist_banner");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //
    getGooList() {
      var _this = this;
      var link = url.getMall("getall_goo");
      $.get(link, {}, res => {
        _this.gooList = res;
      });
    },
    // 查询
    selClick: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    // 删除
    delClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getArt("delete_banner");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        concelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 上传图片
    dialogOpened: function() {
      var _this = this;
      if ($("#uploadBtn1 input").length == 0) {
        $("#uploadBtn1").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          handleType: "0",
          maxSize: 1024 * 1024 * 1,
          onSuccess: function(data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "imgUrl", data.relativeName);
          }
        });
      }
    },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getArt("save_banner");
      var info = this.form;

      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //选择结果
    // gooSelect(e) {
    //   var _this = this;
    //   var gooid = e;
    //   var gooList = this.gooList;
    //   var thisItem = null;
    //   for (var i = 0; i < gooList.length; i++) {
    //     var item = gooList[i];
    //     if (item.id == gooid) {
    //       thisItem = item;
    //       break;
    //     }
    //   }
    //   this.form.linkUrl = "/pages/productdetail/productdetail?id=" + gooid;
    //   this.form.summary = item.title;
    // }
  },
  mounted() {
    //   列表
    this.getList();
    this.getGooList();
    this.getLinkUrl();
  }
};
</script>